module.exports = "<div class=\"confirmationDialog\" ng-class=\"'confirmationDialog--' + confirmationDialog.classes\" ng-show=\"confirmationDialog.showDialog\">\r\n    <div class=\"confirmationDialog-message\">\r\n        {{confirmationDialog.message}}\r\n    </div>\r\n    <button class=\"button button--primary\" ng-click=\"continue()\">Continue</button>\r\n    <button class=\"button\" ng-click=\"cancel()\">Cancel</button>\r\n</div>\r\n<div class=\"confirmationDialog-mask\" ng-show=\"confirmationDialog.showDialog\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/olycommon/confirmation-dialog/confirmation-dialog.directive.html
// module id = 69
// module chunks = 1